export const capitalizeFirstLetter = (value) => {
	if (typeof value !== "string" || value.length === 0) return value;
	return value.replace(/\b\w/g, (char) => char.toUpperCase());
};

export const getCurrentMonthRange = () => {
	const start = new Date();
	start.setDate(1);
	start.setHours(0, 0, 0, 0);

	const axisEnd = new Date();
	axisEnd.setHours(23, 59, 59, 999);

	return { start, end: new Date(), axisEnd };
};

export const getLastMonthRange = () => {
	const now = new Date();

	const start = new Date(now.getFullYear(), now.getMonth() - 1, 1);
	start.setHours(0, 0, 0, 0);

	const end = new Date(now.getFullYear(), now.getMonth(), 0);
	end.setHours(23, 59, 59, 999);

	return { start, end, axisEnd: end };
};

export const getLast30DaysRange = () => {
	const end = new Date();
	end.setHours(23, 59, 59, 999);

	const start = new Date();
	start.setDate(start.getDate() - 29); // 30 days total, inclusive of today
	start.setHours(0, 0, 0, 0);

	return { start, end, axisEnd: end };
};
